import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteAUser, loadUsersData, saveAUser, updateAUser, loadSingleUserData,clearUserErrorMsg} from "../../redux/modules/user";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import GridList from "@material-ui/core/GridList";
import CardUserInformation from "./CardUserInformation";
import * as MainConstants from "../../utils/MainConstants";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import InputMask from "react-input-mask";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {USER_TYPE} from "../../utils/MainConstants";
import Tooltip from "@material-ui/core/Tooltip";
import {clearTowErrorMsg} from "../../redux/modules/towjob";
//import {loadLocationsData} from "../../redux/modules/location";


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#fa692a",
        color:"black",
        textTransform: "unset !important",
        width: '80%',
    },
    gridList: {
        width: 500,
        height:500,
    },
});


class UserForm extends React.Component {
    
    
    state = {
        
        //selectedLocation:{},
        selectedUser:{"country":"U.S.A", "state":"Massachusetts"},
        inputFieldShrinkState:true,
        showServiceTermDialog:false,
        showUserSavedDialog:false
        
    };
    
    constructor(props) {
        super(props);
        this.usertyphere = this.props.usertype;
        
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleFirstnameChange = this.handleFirstnameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleAddress1Change = this.handleAddress1Change.bind(this);
        this.handleLastnameChange = this.handleLastnameChange.bind(this);
        
        this.handleAddress2Change = this.handleAddress2Change.bind(this);
        
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.getListOfUsers = this.getListOfUsers.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleClickShowServiceTerm = this.handleClickShowServiceTerm.bind(this);
        this.handleClickShowServiceTermClose = this.handleClickShowServiceTermClose.bind(this);
        this.handleClickShowServiceTermAgreed = this.handleClickShowServiceTermAgreed.bind(this);
        this.handleClickShowSavedUser = this.handleClickShowSavedUser.bind(this);
        this.handleClickShowSavedUserClose = this.handleClickShowSavedUserClose.bind(this);
        //this.handlePasswordChange = this.handlePasswordChange.bind(this);
        
        
        
    }
    
    
    handleClickShowSavedUser() {
        this.setState({ showUserSavedDialog: true });
    };
    
    
    handleClickShowSavedUserClose() {
        let { clearUserErrorMsg } = this.props;
        this.setState({ showUserSavedDialog: false });
        clearUserErrorMsg();
    };
    
    handleClickShowServiceTermAgreed(){
        this.handleSubmit();
        this.setState({showServiceTermDialog:false});
        
    }
    
    
    handleClickShowServiceTerm() {
        this.setState({showServiceTermDialog:true});
    };
    
    
    handleClickShowServiceTermClose() {
        this.setState({showServiceTermDialog:false});
    };
    
    handleSubmit () {
        
        // this.handleClickShowServiceTerm();
        let { saveAUser } = this.props;
        
        var tempStream = this.state.selectedUser
        tempStream.username="";
        //tempStream.password="";
        
        var tempUserType = this.props.usertype;
        if((tempUserType == null) ||(tempUserType == undefined)){
            tempUserType = USER_TYPE.VEHICLE_DRIVER_USER_TYPE;
        }
        
        tempStream.usertype=tempUserType;
        if((tempStream.address2 == null) ||(tempStream.address2.length == 0)){
            tempStream.address2="  ";
        }
        
        //tempStream.locationId= this.state.selectedLocation.id;
        saveAUser(DEFAULT_VESPAAN_SERVER.url,  tempStream);
        
    };
    
    handleUpdate () {
        let { updateAUser } = this.props;
        
        var tempStream = this.state.selectedUser ;
        tempStream.id=this.props.UserSaveResponse.id;
        tempStream.username=" ";
        //tempStream.password=" ";
        tempStream.usertype=USER_TYPE.VEHICLE_DRIVER_USER_TYPE;
        if((tempStream.address2 == null) ||(tempStream.address2.length == 0)){
            tempStream.address2="  ";
        }
        updateAUser(DEFAULT_VESPAAN_SERVER.url,  tempStream);
        
    };
    
   
    
    handlePhoneChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{phone:event.target.value}));
    }
    
    handleEmailChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{email:event.target.value}));
    }
    handleZipcodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{zipcode:event.target.value}));
    }
    handleCountryChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{country:event.target.value}));
    }
    
    handleStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{state:event.target.value}));
    }
    
    
    handleCityChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{city:event.target.value}));
    }
    
    handleAddress2Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
    }
    
    handleAddress1Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{address1:event.target.value}));
    }
    
    handleFirstnameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{firstName:event.target.value}));
    }
    
    
    handleLastnameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{lastName:event.target.value}));
    }
    
    handlePasswordChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{password:event.target.value}));
    }
    
    handleUsernameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{username:event.target.value}));
    }
    
    handleLocationChange(event) {
        //event.preventDefault();
        this.setState({selectedLocation: event.target.value});
        //this.setState({selectedVideoControllerName: event.target.value.displayName});
    }
    
    
    clearFields = (e) => {
        e.preventDefault();
        this.setState(state => ({
            inputFieldShrinkState:true
        }));
        
        
        var tempSelectedUser =   Object.assign({}, this.state.selectedUser);
        Object.keys(tempSelectedUser).map((key, index) => {
            tempSelectedUser[key] = "" ;
        });
        this.setState({selectedUser:tempSelectedUser})
    };
    
    
    
    renderErrorFiled(data){
    
    
    }
    
    /*refresh(event) {
        let { loadUsersData } = this.props;
        loadUsersData(DEFAULT_VESPAAN_SERVER.url );
    }*/
    
    refresh(){
        let { loadSingleUserData , loadLocationsData } = this.props;
        loadSingleUserData(DEFAULT_VESPAAN_SERVER.url );
        this.setState({
            errorCMsg:{}
        });
    }
    
    
    // saveUserResp
    
    
    getListOfUsers() {
        
        if(this.props.UserSaveResponse != null){
            
            return(<CardUserInformation info={this.props.UserSaveResponse}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardUserInformation> );
        }else{
            return(<p> No User yet!</p>)
        }
    }
    
    /*getListOfUsers() {
        let tempArray = this.props.usersArray;
        let returnArray=[];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                return(<CardUserInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardUserInformation> );
            });
        }
        return(returnArray);
    }
    */
    
    
    
    render() {
        const {classes} = this.props;
        let userCardList = this.getListOfUsers();
        let usStates = MainConstants.getUSStates();
        let canStates = MainConstants.getCanadaStates();
        let availableCountries = MainConstants.getCountries();
        return (
          <React.Fragment>
              <Typography variant="h6" gutterBottom>
                  User Information
              </Typography>
              <Grid container spacing={24}>
                  
                  <Grid item xs={12} sm={12}>
                      {/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */}
                      <Grid container >
                          <Grid item xs={5} sm={5}>
                              {/*
                <Grid container >
                    <Grid item xs={5} sm={5} >
                        <TextField required id="Username" name="username"  label="Username"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.username} onChange={this.handleUsernameChange}/>
                    </Grid>
                    <Grid item xs={2} sm={2} >
                    </Grid>
                    <Grid item xs={5} sm={5} >
                        <TextField required id="Password" name="password"  label="Password"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.password} onChange={this.handlePasswordChange}/>
                    </Grid>
                </Grid>
                */}
                              
                              <Grid container >
                                  <Grid item xs={5} sm={5}>
                                      <TextField required id="firstname" name="firstname"  label="First Name"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.firstName} onChange={this.handleFirstnameChange}/>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid itemxs={5} sm={5} >
                                      <TextField required id="lastname" name="lastname"  label="Last Name"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.lastName} onChange={this.handleLastnameChange}/>
                                  </Grid>
                              </Grid>
                              <Grid item xs={12}>
                                  <TextField  required id="address1" name="address1" label="Address line 1"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.address1} onChange={this.handleAddress1Change}  />
                              </Grid>
                              <Grid item xs={12}>
                                  <TextField id="address2" name="address2" label="Address line 2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.address2} onChange={this.handleAddress2Change} />
                              </Grid>
                              <Grid container >
                                  <Grid item xs={5} sm={5} >
                                      <TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.city} onChange={this.handleCityChange}/>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5} >
                                      {/*<TextField id="state" name="state" label="State/Province/Region" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.state} onChange={this.handleStateChange}/>
                                */}<FormControl className={classes.formControl}>
                                      <InputLabel htmlFor="age-helper">State</InputLabel>
                                      <Select value={this.state.selectedUser.state}
                                              onChange={ this.handleStateChange}
                                              inputProps={{
                                                  name: 'State',
                                                  id: 'state-helper',
                                              }}
                                      >
                                          
                                          {(this.state.selectedUser.country == "U.S.A") &&  (usStates) }
                                          { (this.state.selectedUser.country != "U.S.A") && (canStates)}
                                      
                                      
                                      </Select>
                                      {/* <FormHelperText>Select a State </FormHelperText> */}
                                  </FormControl>
                                  
                                  
                                  
                                  </Grid>
                                  <Grid item xs={5} sm={5}>
                                      <TextField  required  id="zip"  name="zip"  label="Zip / Postal code"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.zipcode} onChange={this.handleZipcodeChange}  />
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5}>
                                      {/*<TextField  required id="country"  name="country"  label="Country"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.country} onChange={this.handleCountryChange} />
                               */}
                                      <FormControl className={classes.formControl}>
                                          <InputLabel htmlFor="age-helper">Country</InputLabel>
                                          <Select value={this.state.selectedUser.country}
                                                  onChange={ this.handleCountryChange}
                                                  inputProps={{
                                                      name: 'country',
                                                      id: 'country-helper',
                                                  }}
                                          >
                                              
                                              {availableCountries}
                                          
                                          </Select>
                                      
                                      </FormControl>
                                  
                                  
                                  
                                  </Grid>
                                  
                                  <Grid item xs={5} sm={5}>
                                      <InputMask mask="(999) 999-9999"   value={this.state.selectedUser.phone} onChange={this.handlePhoneChange}>
                                          {()=>  <TextField  required id="phone"  name="phone"  label="Mobile Phone"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  /> }
                                      
                                      </InputMask>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  
                                  <Grid item xs={5} sm={5}>
                                      <TextField  required  id="email"  name="email"  label="Email"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.email} onChange={this.handleEmailChange}  />
                                  </Grid>
                                  
                                  <Grid item xs={5} sm={5}>
                                      <TextField  required  id="password"  name="password"  label="Password"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.password} onChange={this.handlePasswordChange}  />
                                  </Grid>
                                  <Grid item xs={7} sm={7}>
                                  
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.handleClickShowServiceTerm} className={classes.button}  >
                                          Save User Information
                                      </Button>
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}  >
                                          Update User Information
                                      </Button>
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
                                          Clear Fields
                                      </Button>
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}  >
                                          Refresh Screen
                                      </Button>
                                  </Grid>
                              </Grid>
                          </Grid>
                          <Grid item xs={1} sm={1} >
                          </Grid>
                          <Grid item xs={6} sm={6}>
                              {/* <DynamicTable  data={this.props.usersArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable>  */}
                              { (this.props.usersArray.length != 0) &&
                                (<
                                  Typography
                                  variant = "h6"
                                  gutterBottom >
                                    There
                                    are
                                    {
                                        this.props.usersArray.length
                                    }
                                    users in your
                                    profile.
                                < /Typography>)
                              }
                              
                              { (this.props.UserSaveResponse == null) &&
                                (<
                                  Typography
                                  variant = "h6"
                                  gutterBottom >
                                    You are not registered with {MainConstants.APPLICATION_NAME} system. please fill out the user information, and click on the SAVE button..
                                < /Typography>)
                              }
                              
                              <GridList cellHeight={100} className={classes.gridList}>
                                  { userCardList}
                              </GridList>
                          
                          </Grid>
                          
                          
                          <Grid container >
                              {/* { (this.props.errorCMsg) && (this.props.errorCMsg.status) && (
                        <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Error - Operation Failed" value= {" message = " + this.props.errorCMsg.status + " details = " + this.props.errorCMsg.statusText + " Time = " +  this.props.errorCMsg.timestamp}
                            className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                        </Grid>) */}
                              }
                              {/* {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                    */}
                          </Grid>
                          {/* doing the Service term dialog here. */}
                          
                          <Dialog
                            open={this.state.showServiceTermDialog}
                            onClose={this.handleClickShowServiceTermClose}
                            scroll={'paper'}
                            classes={{
                                paper: classes.formControl2,
                            }}
                            aria-labelledby="scroll-dialog-title"
                            aria-describedby="scroll-dialog-description"
                            maxWidth="xl"
                          >
                              <DialogTitle id="scroll-dialog-title">Service Term Agreement</DialogTitle>
                              <DialogContent  id="farshids"   dividers="paper">
                                  < Typography variant = "h4" gutterBottom >
                                      Trial and Evaluation Terms of Service:
                                  < /Typography>
                                  < Typography variant = "body1" gutterBottom >
                                      
                                      
                                      Access to any product or service of Vespaan Corporation (“Vespaan”) for trial and evaluation purposes is subject to the following
                                      terms and conditions (\ Agreement\).
                                      You (“Client”) accept and agree to be bound by these Terms of Service during the Trial Period.
                                  < /Typography>
                                  < Typography variant = "body1" gutterBottom >
                                      1. The product or service licensed hereunder (the \Product\) is identified in the confirmation email or any other
                                      document that Vespaan provides to Client to confirm Client's access to the Product for the Trial Period specified therein
                                      (the “Trial Period”) for evaluation purposes and includes any documentation, updates and corrections thereto provided by
                                      Vespaan to Client. Subject to and in consideration of Client's compliance with the terms of this Agreement, Vespaan hereby
                                      grants the Client a personal, non-exclusive, non-transferable, royalty-free, revocable license solely for the purpose of
                                      internal trial and evaluation of the Product. Client agrees that its employees or other personnel will be participating in
                                      such internal trial and evaluation of the Product (\Authorized Users\) for the Trial Period. Upon expiration or termination
                                      of this Agreement or Trial Period, unless otherwise instructed by Vespaan or unless Client has transitioned to a production
                                      (non-trial) license for the Product, Client shall cease all use and shall promptly destroy or return the Product (including all
                                      copies) and so certify in writing upon Vespaan\'s request.
                                  < /Typography>
                                  < Typography variant = "body1" gutterBottom >
                                      2. Client shall not alter, modify, or make derivative works of the Product. Client shall not reverse decompile, disassemble or
                                      otherwise reverse engineer the Product in whole or in part. Client shall not duplicate, transfer, disclose, provide, distribute, sell,
                                      lease, republish, sublicense or otherwise make available the Product, or any part or copies thereof, to any third party. Client shall not
                                      remove any copyright, trademark or other proprietary notices from the Product. No title to or ownership of the Product is transferred to Client.
                                      Title to and ownership of the Product and all applicable intellectual property rights and other rights, including without limitation patent,
                                      trademark, copyright and trade secret rights, in the Product remains with Vespaan. The Product provided hereunder is confidential or proprietary
                                      to Vespaan, and Client shall safeguard the Product accordingly.
                                  < /Typography>
                                  < Typography variant = "body1" gutterBottom >
                                      3. THE PRODUCT LICENSED HEREUNDER IS PROVIDED \AS IS\. VESPAAN MAKES NO WARRANTIES, REPRESENTATIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED, IN
                                      RESPECT OF THIS AGREEMENT, THE PRODUCT OR DOCUMENTATION PROVIDED HEREUNDER, AND ALL WARRANTIES INCLUDING BUT NOT LIMITED TO, THE WARRANTIES OF
                                      MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT ARE EXPRESSLY DISCLAIMED. CLIENT AGREES THAT VESPAAN SHALL NOT BE LIABLE FOR
                                      ANY LOSS, CLAIM, OR DAMAGE, TO CLIENT OR ANY THIRD PARTY WHETHER DIRECT OR INDIRECT, WHETHER BASED ON CONTRACT, TORT, OR ANY OTHER LEGAL THEORY
                                      RELATING TO CLIENT\'S USE OR POSSESSION OF OR RELIANCE ON THE PRODUCT INCLUDING WITHOUT LIMITATION ANY INCIDENTAL OR CONSEQUENTIAL DAMAGES OR LOSS
                                      OF PROFIT. CLIENT, ON BEHALF ITSELF AND ITS AUTHORIZED USERS, AGREES NOT TO BRING OR THREATEN TO BRING ANY CLAIM AGAINST VESPAAN OR ANY OF ITS OFFICERS
                                      , DIRECTORS, OWNERS, OR OTHER AFFILIATES, WITH RESPECT TO ANY LIABILITY DISCLAIMED OR EXCLUDED HEREIN.
                                      ""
                                  < /Typography>
                                  < Typography variant = "body1" gutterBottom >
                                      4. Client is not authorized to, agrees not to, and agrees to not permit Authorized Users or others to, use the Product while operating a motor vehicle,
                                      bicycle, or other vehicle. Client shall be responsible for use of the Product and compliance with this Agreement by its Authorized Users.
                                  
                                  < /Typography>
                                  < Typography variant = "body1" gutterBottom >
                                      5. Client may not assign any of its rights or delegate any of its obligations hereunder, and any attempted assignment or delegation shall be null
                                      and void. This Agreement sets forth the entire agreement between the parties and supersedes any and all prior proposals, agreements or communications,
                                      written or oral, of the parties with respect to the subject matter hereof. This Agreement and its performance shall be governed by the laws of the
                                      Commonwealth of Massachusetts, excluding its of law rules. The parties hereby submit to the exclusive jurisdiction of the federal and state courts
                                      located in the Commonwealth of Massachusetts.
                                  < /Typography>
                                  < Typography variant = "body1" gutterBottom >
                                      6. Either party may terminate this Agreement at any time. If Client breaches any of its obligations under this Agreement, Vespaan shall have the right,
                                      in addition to any and all other remedies it may have hereunder, at law or in equity, to be indemnified by the Client against any cost, loss or damage
                                      suffered by Vespaan including Vespaan' attorneys' fees as a result of the said breach or non-compliance. The provisions of Sections 2, 3, 4 and 5 hereof
                                      shall survive termination of this Agreement.
                                  
                                  < /Typography>
                              
                              </DialogContent>
                              <DialogActions>
                                  
                                  
                                  <Button onClick={this.handleClickShowServiceTermAgreed} color="primary">Agree</Button>
                                  <Button onClick={this.handleClickShowServiceTermClose} color="secondary">Disagree</Button>
                              </DialogActions>
                          </Dialog>
                          {/* This is for submit event error/success display */}
                          <Dialog
                            open={this.state.showUserSavedDialog}
                            onClose={this.handleClickShowSavedUserClose}
                            scroll={'paper'}
                            classes={{
                                paper: classes.formControl2,
                            }}
                            aria-labelledby="scroll-dialog-title"
                            aria-describedby="scroll-dialog-description"
                            maxWidth="xl"
                          >
                              <DialogTitle id="scroll-dialog-title">User Information</DialogTitle>
                              <DialogContent id="farshids" dividers="paper">
                                  
                                  {((this.props.errorCMsg!= null) && (this.props.errorCMsg.status == 200)) && (<div>
                                      The Operation was SUCCESSFUL! Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
                                  </div>)}
                                  {((this.props.errorCMsg != null) && (this.props.errorCMsg.status != 200) )&& (this.props.errorCMsg.status != null) && (<div>
                                      The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
                                  </div>)}
                              
                              </DialogContent>
                              <DialogActions>
                                  {/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
                                  
                                  <Button onClick={this.handleClickShowSavedUserClose} color="secondary">Close</Button>
                              </DialogActions>
                          </Dialog>
                          {/* end of Emailselection*/}
                      </Grid>
                  
                  </Grid>
              </Grid>
          
          
          
          
          </React.Fragment>
        );
    }//end of render
    
    
    
    editRecord(singleRowData){
        this.setState({inputFieldShrinkState:true});
        this.setState({selectedUser:singleRowData });
        //We need to change the seleted Location as well.
        //let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );
        
        //this.setState({selectedLocation:tempLocation });
        
    }
    
    
    deleteRecord(argProcessId){
        //alert('I am deleting ' + argCameraId);
        let { deleteAUser } = this.props;
        deleteAUser(DEFAULT_VESPAAN_SERVER.url,argProcessId  );
    }
    
    
    
    
    
    componentWillMount(){
        let { loadSingleUserData , loadLocationsData } = this.props;
        loadSingleUserData(DEFAULT_VESPAAN_SERVER.url );
        //loadLocationsData("http://localhost:9065/" );
        
        this.setState({
            errorCMsg:{}
        });
    }
    
    
    componentDidMount(){
        //let { loadUsersData , loadLocationsData } = this.props;
        //loadUsersData(DEFAULT_VESPAAN_SERVER.url );
        //loadLocationsData("http://localhost:9065/" );
        
        this.setState({
            errorCMsg:{}
        });
    }
    
    /*
				componentWillReceiveProps(nextProps) {
					 if(nextProps.errorCMsg.status != null) {
							if (nextProps.errorCMsg.status != null) {
								this.handleClickShowSavedTow();
							}
						}
				}
				*/
    
    /*componentWillReceiveProps(nextProps) {
        if (this.props.UserSaveResponse !== nextProps.UserSaveResponse) {
            this.setState({
                UserSaveResponse: nextProps.UserSaveResponse
            });
        }
    }*/
    
    componentWillReceiveProps(nextProps) {
        if(nextProps.errorCMsg != null) {
            
            if (nextProps.errorCMsg.status != null) {
                if (nextProps.errorCMsg.status != null) {
                    this.handleClickShowSavedUser();
                }
            }
        }
    }
    
    
    
}//end of class

UserForm.propTypes = {
    classes: PropTypes.object.isRequired,
    usertype: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    return {
        usersArray: state.user.usersArray,
        UserDeleteResponse:state.user.deleteUserResp,
        UserSaveResponse:state.user.saveUserResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg:state.user.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadUsersData:loadUsersData,
        loadSingleUserData:loadSingleUserData,
        deleteAUser:deleteAUser,
        saveAUser:saveAUser,
        updateAUser:updateAUser,
        clearUserErrorMsg:clearUserErrorMsg,
        
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserForm));
